import { AppProvider } from "containers"
import { AuthLayout, PrivateLayout } from "layouts"
import { BrowserRouter, Route, Routes } from "react-router-dom"

const App = () => {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AuthLayout />} path="/auth/*" />
          <Route element={<PrivateLayout />} path="/*" />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  )
}

export default App
